var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LedgerModal',{staticClass:"ledger-request",attrs:{"title":_vm.$t('ledger.modal.request')}},[_c('LedgerModalNanoS'),_c('AeSpinner'),_c('ModalHeader',[_vm._v(" "+_vm._s(_vm.$t('ledger.modal.request'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }